import React from "react";
import { Link } from "react-router-dom";

const CustomLink: React.FC<React.PropsWithChildren<{ to: string }>> = ({
  to,
  children,
}) => {
  return (
    <Link
      to={to}
      className="text-blue-500 hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-500 transition-colors duration-200"
    >
      {children}
    </Link>
  );
};

export default CustomLink;
